



















import { ClientRoutes } from "@/data/enums/router";
import { ClientTemplateSlotCodes } from "@/data/enums/templates";
import { IClient } from "@/models/clients";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    "legacy-invoices-provider": () =>
      import(
        "@/components/app/global/legacyInvoices/legacyInvoicesProvider.vue"
      ),
    "legacy-invoices-table": () =>
      import("@/components/app/global/legacyInvoices/legacyInvoicesTable.vue"),
    "client-template-render-provider": () =>
      import(
        `@/components/app/global/templates/clientTemplateRenderProvider.vue`
      )
  }
})
export default class ClientLegacyInvoices extends Vue {
  // Props

  @Prop({ required: true })
  public client!: IClient;

  // Life-cycle methods

  public created() {
    if (!this.client?.import_id)
      return this.$router.replace({ name: ClientRoutes.INVOICES });
  }

  // Computed

  public get clientTemplateProps() {
    return {
      code: ClientTemplateSlotCodes.LEGACY_INVOICES_OVERVIEW,
      objectId: this.client?.id
    };
  }
}
